import React from 'react';

import Radio from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { hasRoles, ROLE_PRIME_QUERY, ROLE_PRIME_PLUS } from '../services/user';

// eslint-disable-next-line max-len
export default function PrimeSwitch({ homologatorId, value, hasPrimePlus = false, onChange, defaultOption, required, customTemplateData }) {
  const primeCapable = hasRoles(ROLE_PRIME_PLUS) || hasRoles(ROLE_PRIME_QUERY);
  const AngelliraHomolohatorId = 5;

  const canPrime = homologatorId !== AngelliraHomolohatorId && hasRoles(ROLE_PRIME_QUERY);
  const canPrimePlus = hasRoles(ROLE_PRIME_PLUS)
    && (hasPrimePlus || homologatorId === AngelliraHomolohatorId);

  const isCustomTemplateDataEmpty = customTemplateData?.length === undefined ||
    customTemplateData.length === 0;
  const withoutPrimeAndPlus = !canPrime && !canPrimePlus && isCustomTemplateDataEmpty;

  return <FormControl required={required}
    component="fieldset" margin="normal" style={{ marginBottom: '-5px' }}>
    <FormLabel component="legend">Tipo da Consulta</FormLabel>

    <RadioGroup
      name="prime"
      value={value}
      onChange={onChange}
      required={required}
      row
    >
      {
        (homologatorId !== AngelliraHomolohatorId && primeCapable && defaultOption)
        || (homologatorId === AngelliraHomolohatorId && hasRoles(ROLE_PRIME_PLUS) && defaultOption)
        || withoutPrimeAndPlus
          ? <FormControlLabel value={'0'} control={<Radio color="primary" />} label="Padrão" />
          : null
      }

      {
        canPrime
          ? <FormControlLabel value={'1'} control={<Radio color="primary" />} label="Prime" />
          : null
      }

      {
        canPrimePlus
          ? <FormControlLabel value={'2'} control={<Radio color="primary" />} label="Prime Plus" />
          : null
      }
    </RadioGroup>
  </FormControl>;
}
